import React from "react";
import { Dropdown, Menu, Progress, Typography, Space, Button, Row, Col } from "antd";
import { UserOutlined, CreditCardOutlined, SettingOutlined, LogoutOutlined, CaretUpOutlined } from "@ant-design/icons";
import Avatar from "boring-avatars";
import Meta from "../Meta";
import useAuthStore from "../../states/useAuth";
import useAuth from "../../hooks/useAuth";

const { Text, Title } = Typography;

const AvatarDropdown = ({ isApprover, ...props }) => {
  const { user } = useAuthStore();
  const { signOut } = useAuth();

  const menu = (
    <Menu style={{ width: 300, padding: "16px" }}>
      <div style={{ textAlign: "center", marginBottom: "16px" }}>
        <Avatar size={64} name={user?.name} />
        <Title level={4} style={{ margin: "8px 0 0" }}>
          {user?.name}
        </Title>
        <Text type="secondary">{user?.email}</Text>
      </div>
      {/* <Menu.Item key="credits" style={{ background: "#f0f9eb", borderRadius: "8px", marginBottom: "8px" }}>
        <Space direction="vertical" style={{ width: "100%", fontSize: "1rem" }}>
          <Space>
            <CreditCardOutlined />
            <Text strong>Account Credits</Text>
            <Text style={{ marginLeft: "auto" }}>Basic Plan</Text>
          </Space>
          <Text>Used 32 of 300</Text>
          <Progress percent={32 / 3} showInfo={false} strokeColor="#52c41a" />
          <Text type="secondary">Limit reset in 29 days</Text>
        </Space>
      </Menu.Item>
      <Menu.Item
        key="upgrade"
        style={{ background: "var(--ion-color-step-50)", borderRadius: "8px", marginBottom: "8px" }}
      >
        <Space direction="vertical" style={{ width: "100%", fontSize: "1rem" }}>
          <Space>
            <CreditCardOutlined />
            <Text strong>Run out of usage?</Text>
          </Space>
          <Text type="secondary">Upgrade to Premium to for higher limits.</Text>
          <Button icon={<CaretUpOutlined />} style={{ background: "black", color: "white", marginBottom: "0.5rem" }}>
            Upgrade to Premium
          </Button>
        </Space>
      </Menu.Item>
      <Menu.Item key="plans" icon={<CreditCardOutlined />} style={{ marginBottom: "0.5rem" }}>
        <span style={{ fontSize: "1rem" }}>Plans</span>
      </Menu.Item>
      <Menu.Item key="account" icon={<SettingOutlined />} style={{ marginBottom: "0.5rem" }}>
        <span style={{ fontSize: "1rem" }}>Account</span>
      </Menu.Item> */}
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined />}
        onClick={() => {
          signOut();
        }}
      >
        <span style={{ fontSize: "1rem" }}>Logout</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      <Meta
        className="hover-wrapper"
        style={{ ...props.style }}
        image={<Avatar size={30} name={user?.name} />}
        title={
          <Text
            strong
            style={{
              maxWidth: "7rem", // Set your desired maxWidth
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {user?.name}
          </Text>
        }
        description={isApprover ? "Approver" : "Merchant User"}
      />
    </Dropdown>
  );
};

export default AvatarDropdown;
